module.exports = __webpack_public_path__ + "img/circle-chevron-up.79746161.svg";